import React, { useState,useEffect } from "react";
import {
  IonButtons,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonLabel,
  IonInput,
  IonToast,
  IonText,
  IonPage,
  IonContent,
  IonAlert,
  IonFooter,
  IonTextarea,
  IonList
} from "@ionic/react";
import { useHistory } from "react-router";
import * as firebase from "firebase";
import { observer, MobXProviderContext } from "mobx-react";

const LoginPage = () => {
  const { store } = React.useContext(MobXProviderContext);
  let { isAuth, initializationError } = store;
  const history = useHistory();
  const [remote_user_id, setRemoteUserId] = useState("");
  const [user_id, setUserId] = useState("");
  const [errorInfo, setErrorInfo] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [connected, setConnected] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [mid, setMid] = useState("");
  /**
   *
   */
  const _doLogin = async () => {
    firebase
      .firestore()
      .collection("users")
      .doc('U'+remote_user_id)
      .set({
        user_id:'U'+remote_user_id,
        request:true,
        ruser_id:'U'+user_id,
        connected:false
      });
  };

  useEffect(() => {
    return handleClick();
  }, []);
  const handleClick = () =>{
    const onResult = (querySnapshot)=>{
      var data = querySnapshot.data();
      if(data.request){
        setShowAlert(true);
      }
      if(data.ruser_id!="" && data.ruser_id!=undefined && data.ruser_id!=null){
        window.localStorage.setItem('ruserid',data.ruser_id);
      }
      if(data.connected){
        setConnected(true);
        initMessages(data);
      }
    }
    const onError = (error)=>{

    }

    var rand = "";
    if(window.localStorage.getItem('userid')==null){
      const min = 100000;
      const max = 999999;
      rand = Math.round(min + Math.random() * (max - min));
      window.localStorage.setItem('userid',rand);
    }
    else{
      rand = window.localStorage.getItem('userid');
    }
    setUserId(rand);
    store.doCreateUser({user_id:'U'+rand});
    const unsubscribe = firebase.firestore().collection('users').doc('U'+rand).onSnapshot(onResult, onError);
    return unsubscribe;
  }
  const initMessages = (data)=>{
    let rid = parseFloat(data.ruser_id.replace('U',''));
    let uid = parseFloat(data.user_id.replace('U',''));
    setRemoteUserId(rid);console.log(rid)
    var mid1 = uid>rid?rid+'_'+uid:uid+'_'+rid;
    console.log(mid1)
    const onResult1 = (querySnapshot)=>{
      var marr = [];
      querySnapshot.forEach(d=>{
        marr.push(d.data());
      });
      setMessages(marr);
    }
    const onError1 = (error)=>{

    }
    setMid(mid1);
    const unsubscribe = firebase.firestore().collection('messages').doc(mid1).collection('list').onSnapshot(onResult1, onError1);
  }
  const connectUser = () => {
    let ruser_id = window.localStorage.getItem('ruserid');
    firebase
      .firestore()
      .collection("users")
      .doc(ruser_id)
      .set({
        user_id:ruser_id,
        request:false,
        ruser_id:'U'+user_id,
        connected:true
      });
    firebase
      .firestore()
      .collection("users")
      .doc('U'+user_id)
      .set({
        user_id:'U'+user_id,
        request:false,
        ruser_id:ruser_id,
        connected:true
      });
  }
  const _sendMessage = () => {
    console.log(mid)
    firebase.firestore().collection('messages').doc(mid).collection('list').add({message:message});
    setMessage("");
  }
  return (
    <IonPage>
      <IonContent className="ion-padding">
        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => setShowAlert(false)}
          header="Connect"
          subHeader="Are you sure?"
          buttons={['Cancel',{
                text: 'Connect',
                role: 'confirm',
                handler: () => {
                  connectUser();
                },
              }]}
        />
        <IonText color="danger" padding style={{ fontWeight: "500" }}>
          {initializationError && initializationError.message}
        </IonText>
        {connected?<div>
          <h2>{remote_user_id} Connected</h2>
          <div className="messages">
            <IonList>
              {messages.map(function(d, idx){
                 return (<IonItem key={idx}><IonLabel>{d.message}</IonLabel></IonItem>)
               })}
            </IonList>
          </div>
        </div>:<div>
        <IonText style={{'textAlign':'center'}}><h4 style={{margin: 0,position: 'relative', top: '20px',  left: '-60px',  fontSize: '20px'}}>My One Hot Code</h4><h2>{user_id}</h2></IonText>
        <IonItem>
          <IonInput
            type="number"
            onIonChange={(e) => {
              setRemoteUserId(e.detail.value);
            }}
            name="user_id"
            value={remote_user_id}
            placeholder="Remote ID"
          />
        </IonItem>
        <div style={{ padding: 10, paddingTop: 20 }}>
          <IonButton
            expand="full"
            style={{ margin: 14 }}
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _doLogin(history);
            }}
          >
            {"Connect"}
          </IonButton>
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px', paddingBottom: '20px' }}>
          <IonText color="medium" style={{ fontSize: '14px' }}>
            Powered by <a href="https://aekam.ai/" target="_blank" rel="noopener noreferrer" style={{ color: '#c1121f', textDecoration: 'none', fontWeight: 'bold' }}>Aekam.ai</a>
          </IonText>
        </div>
        </div>}

        <div id="otpless-login-page"></div>
        <IonToast
          color="danger"
          isOpen={errorInfo.showErrorToast}
          onDidDismiss={() => setErrorInfo({ showErrorToast: false })}
          message={errorInfo.errMsg}
          duration={2000}
        />
      </IonContent>
      {connected?<IonFooter><IonItem>
          <IonTextarea
            onIonChange={(e) => {
              setMessage(e.detail.value);
            }}
            value={message}
            name="message"
          />
        </IonItem>
        <IonItem style={{position: 'absolute', bottom: '0px',right: '0px'}}>
        <IonButton
            expand="full"
            style={{ margin: 14 }}
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _sendMessage();
            }}
          >
            {"Send"}
          </IonButton>
        </IonItem>
        </IonFooter>:null}
    </IonPage>
  );
};

export default observer(LoginPage);
